var ImgSlider = ( function () {
  $( '.content-img-slider__slides' ).slick( {
    centerPadding: '0px',
    nextArrow: ".content-img-slider__next",
    prevArrow: "",
    fade: true,
    dots: true,
    dotsClass: 'slick-dots',
    appendDots: ".content-img-slider__controller .content-img-slider__dots"
  } );
}() );

var CarouselSlider = ( function () {

	function setBoundries(slick, state) {
    if (state === 'default') {
      slick.find('ul.slick-dots li').eq(4).addClass('n-small-1');
    }
  }

  // Slick Selector.
  var slickSlider = $('.carousel__images');
  var maxDots = 4;
  var transformXIntervalNext = -18;
  var transformXIntervalPrev = 18;

  slickSlider.on('init', function (event, slick) {
    $(this).find('ul.slick-dots').wrap("<div class='slick-dots-container'></div>");
    $(this).find('ul.slick-dots li').each(function (index) {
      $(this).addClass('dot-index-' + index);
    });
    $(this).find('ul.slick-dots').css('transform', 'translateX(0)');
    setBoundries($(this),'default');
  });

  var transformCount = 0;
  slickSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var totalCount = $(this).find('.slick-dots li').length;
    if (totalCount > maxDots) {
      if (nextSlide > currentSlide) {
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('n-small-1')) {
          if (!$(this).find('ul.slick-dots li:last-child').hasClass('n-small-1')) {
            transformCount = transformCount + transformXIntervalNext;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('n-small-1');
            var nextSlidePlusOne = nextSlide + 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('n-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var pPointer = nextSlide - 3;
            var pPointerMinusOne = pPointer - 1;
            $(this).find('ul.slick-dots li').eq(pPointerMinusOne).removeClass('p-small-1');
            $(this).find('ul.slick-dots li').eq(pPointer).addClass('p-small-1');
          }
        }
      }
      else {
        if ($(this).find('ul.slick-dots li.dot-index-' + nextSlide).hasClass('p-small-1')) {
          if (!$(this).find('ul.slick-dots li:first-child').hasClass('p-small-1')) {
            transformCount = transformCount + transformXIntervalPrev;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlide).removeClass('p-small-1');
            var nextSlidePlusOne = nextSlide - 1;
            $(this).find('ul.slick-dots li.dot-index-' + nextSlidePlusOne).addClass('p-small-1');
            $(this).find('ul.slick-dots').css('transform', 'translateX(' + transformCount + 'px)');
            var nPointer = currentSlide + 3;
            var nPointerMinusOne = nPointer - 1;
            $(this).find('ul.slick-dots li').eq(nPointer).removeClass('n-small-1');
            $(this).find('ul.slick-dots li').eq(nPointerMinusOne).addClass('n-small-1');
          }
        }
      }
    }
  });

  $('.carousel__images').slick( {
    centerMode: true,
    centerPadding: '180px',
    slidesToShow: 3,
    nextArrow: '<button type="button" class="content-img-slider__next slick-next pull-right"><img src="https://media-jackcanfield.s3.amazonaws.com/assets/wp/common/icon-gradient-arrow-next.png"></button>',
    prevArrow: null,
    responsive: [ {
        breakpoint: 1000,
        settings: {
          centerPadding: '40px',
        }
      },
      {
        breakpoint: 600,
        settings: {
					centerMode: false,
          arrows: false,
          centerPadding: false,
          slidesToShow: 1,
					focusOnSelect: true,
          dots: true,
					infinite: false
        }
      }
    ]
  } );
}() );

var AnimateBounce = ( function () {
	$('.front-page-banner__content').addClass('animated bounce');
}() );

var ScrollReveal = ( function () {
	ScrollReveal().reveal('.col--thirds', {
		delay: 600,
    interval: 80,
		useDelay: 'onload',
		distance: '150%',
    origin: 'bottom'
	});
	ScrollReveal().reveal('.steps__col', {
		delay: 600,
    interval: 80,
		useDelay: 'onload',
		distance: '150%',
    origin: 'bottom'
	});
	ScrollReveal().reveal('.stacked__media', {
		delay: 600,
    interval: 80,
		useDelay: 'onload',
		distance: '150%',
    origin: 'left'
	});
	ScrollReveal().reveal('.stacked__content', {
		delay: 600,
		interval: 80,
    interval: 3000,
		distance: '150%',
    origin: 'left'
	});
}() );

// var HowItWorksEqualHeightSection = ( function () {
// 	var maxHeight = 0;
// 	var width = $(window).width();

// 	if (width <= 1116) {
// 		$('.steps__headline').each(function() {
// 			if(maxHeight < $(this).outerHeight()) {
// 				maxHeight = $(this).outerHeight();
// 			}
// 		});
// 		$('.steps__headline').height(maxHeight);
// 	}

// 	$(window).resize(function() {
//     var width = $(window).width();
//     if (width <= 1116) {
//       $('.steps__headline').each(function() {
//         if(maxHeight < $(this).outerHeight()) {
//           maxHeight = $(this).outerHeight();
//         }
//       });
//       $('.steps__headline').height(maxHeight);
//     }
//   }).resize(); //trigger the resize event on page load.

// }() );

var EqualHeightSection = ( function () {
	var maxHeight = 0;
	var maxHeightHeadline = 0;

	$(window).resize(function() {
    var width = $(window).width();
    if ( window.innerWidth >= 740) {
      $('.blog-cards__text').each(function() {
        if(maxHeight < $(this).outerHeight()) {
          maxHeight = $(this).outerHeight();
        }
      });
      $('.blog-cards__text').height(maxHeight);
    }
  }).resize(); //trigger the resize event on page load.

	$(window).resize(function() {
    var width = $(window).width();
    if ( window.innerWidth >= 740) {
      $('.blog-cards__headline').each(function() {
        if(maxHeightHeadline < $(this).outerHeight()) {
          maxHeightHeadline = $(this).outerHeight();
        }
      });
      $('.blog-cards__headline').height(maxHeightHeadline);
    }
  }).resize(); //trigger the resize event on page load.

}() );

var OptinPop = ( function () {
  var body = document.body;
  var optinBox = document.querySelector( '.optin-box' );
  var form = document.querySelector( '.optin-box form' );
  var triggerOpen = document.querySelector( ".optin-box__trigger" );
  var triggerClose = document.querySelectorAll( '.optin-box__close' );
  var triggerNext = document.querySelector( '.optin-box__next' );
  var step1Container = document.querySelector( '.optin-box__step-1' );
  var step2Container = document.querySelector( '.optin-box__step-2' );

  function showOptin( blnShow ) {
    if ( blnShow ) {
      optinBox.classList.add( 'optin-box--show' );
      body.classList.add( 'no-scroll' );
    } else {
      optinBox.classList.remove( 'optin-box--show' );
      body.classList.remove( 'no-scroll' );

      step1Container.classList.add( 'optin-box__step--current' );
      step2Container.classList.remove( 'optin-box__step--current' );
    }
  }

  function submitForm( e ) {
    console.log( 'form submitted' );
    // console.log( this );
    // e.preventDefault();
  }

  triggerOpen.addEventListener( 'click', function ( e ) {
    e.preventDefault();
    showOptin( true );
  } );

  triggerClose.forEach( function ( trigger ) {
    trigger.addEventListener( 'click', function ( e ) {
      showOptin( false );
    } );
  } );

  triggerNext.addEventListener( 'click', function () {
    step1Container.classList.remove( 'optin-box__step--current' );
    step2Container.classList.add( 'optin-box__step--current' );
  } );

  form.addEventListener( 'submit', submitForm );
}() );

jQuery(document).ready(function($){
  $(".optin-box__submit").on('click', function(){
    if($('form').parsley().validate() === true) {
      $('form').submit();
    }
  });
});
